import { Client } from 'urql'
import { Mutation_Root } from 'src/@types/graphql'
import { deleteFeatureTypeConfigById } from 'src/screens/administration/configuration-management/features-configuration/feature-types/featureTypesConfigQueries'

export const deleteFeatureTypeConfig = (urqlClient: Client) => async (featureTypeId: number) => {
  const { data, error } = await urqlClient
    .mutation<{ delete_feature_type_config: Mutation_Root['delete_feature_type_config'] }, { featureTypeId: number }>(
      deleteFeatureTypeConfigById,
      { featureTypeId },
    )
    .toPromise()

  if (error || data?.delete_feature_type_config?.affected_rows !== 1) {
    throw new Error('Feature type config deletion error')
  }

  return true
}
